import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import DesktopNav from "./nav/DesktopNav";
import MobileNav from "./nav/MobileNav";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-lg border-b border-gray-100/50 shadow-soft">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <img
              src="https://customer-assets.emergentagent.com/job_e6aa7c2c-d03d-4974-9cb2-630ed0a0b376/artifacts/e7qtpwyy_Bazaart_2CA00B66-0594-4702-AC94-D9D6D5BB8442%20%281%29.JPEG"
              alt="RNB Consulting Group"
              className="h-12 w-auto rounded-lg"
            />
          </Link>

          <DesktopNav />

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-rnb-navy" />
            ) : (
              <Menu className="h-6 w-6 text-rnb-navy" />
            )}
          </button>
        </div>

        <MobileNav open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
      </nav>
    </header>
  );
};

export default Navbar;
